import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { timeout, catchError, map, tap } from 'rxjs/operators';
import { Route } from '../interfaces/route';
import { MessageService } from '../services/message.service';
import { GlobalVariables } from '../common/global-variables';

const routesUrl = "assets/json/routes.json";

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  public realtime: boolean = true;

  private busMaxCols: number = 5;
  private otherMaxCols: number = 2;

  private alertSummaryUrl = 'https://www3.septa.org/api/Alerts/?callback=jsonp_callback1';
  private data: any = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public systemStatus: any = [];

  constructor(private http: HttpClient,  private messageService: MessageService) { }

  /** GET routes from api */
  get (): Observable<any[]> {

    this.data = this.http.jsonp<Route[]>(this.alertSummaryUrl, 'callback')
    .pipe(
      timeout(GlobalVariables.timeout),
      map ((array: any) => array = this.transform(array, true)),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<Route[]>('get', []))
    );

    return this.data;
  }

  /** Transform the alert summary api to new structure
   *  I had to do this to make life easier...
   *  When scaling SS the tab menu for the mode gets messed up
   *  Since I can only fit 4 items, Subway, NHSL, and CCT get added together as others.
   *  Also the row/col in bootstrap needed to have an array to build properly in angular.
   *  Sorry.
   * **/
  private transform(reponse: any, realtime: boolean): any{
    var transformed: any[] = [];
    transformed['bus'] = [];
    transformed['rail'] = [];
    transformed['subway'] = [];
    transformed['nhsl'] = [];
    transformed['trolley'] = [];
    transformed['cct'] = [];
    transformed['others'] = [];
    var b: any[] = []; //Bus
    var r: any[] = []; //Rail
    var s: any[] = []; //Subway
    var n: any[] = []; //NHSL
    var t: any[] = []; //Trolley
    var c: any[] = []; //CCT
    var o: any[] = []; //Others (Subway + NHSL + CCT)
    var bi: number = 1; //Bus index
    var ri: number = 1; //Rail index
    var si: number = 1; //Subway index
    var ni: number = 1; //NHSL index
    var ti: number = 1; //Trolley index
    var ci: number = 1; //CCT index
    var oi: number = 1; //Others (Subway + NHSL + CCT) index
    for (const d of (reponse as any)){
      if(d.mode == 'Bus'){
        b.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(bi === this.busMaxCols){
          transformed['bus'].push(b);
          b = [];
          bi = 1;
        }
        else{
          bi++;
        }
      }
      if(d.mode == 'Regional Rail'){
        r.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(ri === this.otherMaxCols){
          transformed['rail'].push(r);
          r = [];
          ri = 1;
        }
        else{
          ri++;
        }
      }
      if(d.mode == 'Market/ Frankford' || d.mode == 'Broad Street Line'){
        s.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(si === this.otherMaxCols){
          transformed['subway'].push(s);
          s = [];
          si = 1;
        }
        else{
          si++;
        }
      }
      if(d.mode == 'Norristown High Speed Line'){
        n.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(ni === this.otherMaxCols){
          transformed['nhsl'].push(n);
          n = [];
          ni = 1;
        }
        else{
          ni++;
        }
      }
      if(d.mode == 'Market/ Frankford' || d.mode == 'Broad Street Line' || d.mode == 'Norristown High Speed Line' || d.mode == 'CCT' ){
        o.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(oi === this.otherMaxCols){
          transformed['others'].push(o);
          o = [];
          oi = 1;
        }
        else{
          oi++;
        }
      }
      if(d.mode == 'Trolley'){
        t.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(ti === this.otherMaxCols){
          transformed['trolley'].push(t);
          t = [];
          ti = 1;
        }
        else{
          ti++;
        }
      }
      if(d.mode == 'CCT' ){
        c.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: d.sequence,
          description: d.description,
          alert: d.current_message,
          advisory: d.advisory_message,
          detours: [],
          elevators: d.elevator,
          isalert: (d.isalert === 'N') ? false : true,
          isadvisory: (d.isadvisory === 'No') ? false : true,
          isdetour: (d.isdetour === 'N') ? false : true,
          iselevator: (d.iselevator === 'N') ? false : true,
          isweather: (d.isSnow === 'N') ? false : true,
          issuspended: (d.issuppend === 'N') ? false : true
        });

        if(ci === this.otherMaxCols){
          transformed['cct'].push(c);
          c = [];
          ci = 1;
        }
        else{
          ci++;
        }
      }
    }

    if(b.length > 0){
      transformed['bus'].push(b);
    }
    if(r.length > 0){
      transformed['rail'].push(r);
    }
    if(s.length > 0){
      transformed['subway'].push(s);
    }
    if(n.length > 0){
      transformed['nhsl'].push(n);
    }
    if(t.length > 0){
      transformed['trolley'].push(t);
    }
    if(c.length > 0){
      transformed['cct'].push(c);
    }
    if(o.length > 0){
      transformed['others'].push(o);
    }

    transformed['meta'] = [{ realtime : realtime  }];

    return transformed;
  }

    private handleError<T> (operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log('${operation} failed: ${error.message}');

        //Mark relatime as false to display the error message.
        this.realtime = false;

        //Load the stored routes.json show no data message.
        return this.http.get(routesUrl)
        .pipe(
          map ((array: any) => array = this.transform(array, false)),
          tap (_ => this.log('fetched routes')),
          catchError (this.Failure<any[]>('get', []))
        );
      };
    }

    private Failure<T> (operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log('${operation} failed: ${error.message}');

        // Let the app keep running by returning an empty result.
        return of(result as T);
      };
    }

    /** Log a RouteService message with the MessageService */
    private log(message: string) {
      this.messageService.add(`RouteService: ${message}`);
    }
}
